import fetch from '../config/fetch';

/** productdata **/
export const GetProductInfo = (data) => fetch('AppInfo/ProductInfo',data, 'get','auth');

/** login  **/
export const postLogin = (data) => fetch('Account/GetToken',data, 'post');

/** RefreshToken  **/
export const RefreshToken = (data) => fetch('Account/RefreshToken',data, 'get','auth');

/** Register  **/
export const Register = (data) => fetch('Account/Register',data, 'post');

export const SendVerifCode = (data) => fetch('Account/SendVerifCode',data, 'post');

/** GetMemberInfo  **/
export const GetMemberInfo = (data) => fetch('Profile/GetMemberInfo',data, 'post','auth');

export const GetMemberDetail = (data) => fetch('Profile/GetMemberDetail',data, 'get','auth');

/** Save PWD  **/
export const savePWD = (data) => fetch('Account/SavePWD',data, 'post','auth');

/** RestPwd  **/
export const RestPwd = (data) => fetch('Account/RestPwd',data, 'post');

/** ForgetMemPwd  **/
export const ForgetMemPwd = (data) => fetch('Account/ForgetMemPwd',data, 'post');

/** ChangePwd  **/
export const ChangeMemPwd = (data) => fetch('Account/ChangeMemPwd',data, 'post','auth');

/** GetPoint  **/
export const GetPoint = (data) => fetch('Account/GetPoint',data, 'get','auth');

/** GetCurencyPlan  **/
export const GetCurencyPlan = (data) => fetch('Account/GetCurencyPlan',data, 'get','auth');

/** Log  **/
export const GetHistoryLog = (data) => fetch('History/UseLog',data, 'get','auth');

export const GetOrderLog = (data) => fetch('History/OrderLog',data, 'get','auth');

export const GetPurchaseLog = (data) => fetch('History/PurchaseLog',data, 'get','auth');

/******** Home Card **********/
export const GetHomeCard = (data) => fetch('Home/HomeCard',data, 'get','auth');

/******** Daily Card **********/
export const GetDailyCard = (data) => fetch('Home/GetDailyCard',data, 'get','auth');



/** Analysis  **/
/******** 個人流年 **********/
export const GetAllyearFree = (data) => fetch('Analysis/Allyear/Free',data, 'get','auth');
export const PostAllyearVip = (data) => fetch('Analysis/Allyear/Vip',data, 'post','auth');
/******** 本人個性 **********/
export const GetPersonalityFree = (data) => fetch('Analysis/Personality/Free',data, 'get','auth');
export const PostPersonalityVip = (data) => fetch('Analysis/Personality/Vip',data, 'post','auth');
/******** 客戶 **********/
export const PostClientVip = (data) => fetch('Analysis/Client/Vip',data, 'post','auth');
/******** 情侶 **********/
export const PostLoverVip = (data) => fetch('Analysis/Lover/Vip',data, 'post','auth');
/******** 親友 **********/
export const PostRelativewesVip = (data) => fetch('Analysis/Relativewes/Vip',data, 'post','auth');
/******** 職場 **********/
export const PostColleagueVip = (data) => fetch('Analysis/Colleague/Vip',data, 'post','auth');
/******** 電話 **********/
export const PostPhoneFree = (data) => fetch('Analysis/PhoneNumber/Free',data, 'post','auth');
export const PostPhoneVip = (data) => fetch('Analysis/PhoneNumber/Vip',data, 'post','auth');
/******** 高手過招 **********/
export const PostGameblingFree = (data) => fetch('Analysis/Gamebling/Free',data, 'post','auth');
export const PostGameblingVip = (data) => fetch('Analysis/Gamebling/Vip',data, 'post','auth');
/******** 整體 **********/
export const PostOverallVip = (data) => fetch('Analysis/Overall/Vip',data, 'post','auth');
/******** 歷史結果 **********/
export const PostAnaHistory = (data) => fetch('Analysis/AnaHistory',data, 'post','auth');
/******** 問券 **********/
export const PostPrecision = (data) => fetch('Analysis/Precision',data, 'post','auth');

/** Ecpay  **/
export const Ecpay = (data) => fetch('Shop/ECpay',data, 'post','auth');
export const getTrandno = (data) => fetch('Shop/Trandno',data, 'get','auth');

/** Product  **/
export const getProduct = (data) => fetch('Shop/Product',data, 'get','auth');
/** MasterTips  **/
export const MasterTips = (data) => fetch('Master/Tips',data, 'get','auth');

/** Sales Area  **/
/******** 邀請方案 使用者**********/
export const getInvite = (data) => fetch('Sales/Invite',data, 'get','auth');
export const delInvitePlanClean = (data) => fetch('Sales/InvitePlanClean',data, 'delete','auth');
export const SalesEcpay = (data) => fetch('VipShop/SalesECpay',data, 'post','auth');
export const SalesNBpay = (data) => fetch('VipShop/SalesNBpay?pay=y',data, 'post','auth');

export const PuidDo = (data) => fetch('VipShop/PuidDo',data, 'post','auth');

export const PointGift= (data) => fetch('Sales/PointGift',data, 'post','auth');
/******** 邀請方案 業務**********/
export const SearchClient = (data) => fetch('Sales/SearchClient',data, 'get','auth');
export const InviteClient = (data) => fetch('Sales/InviteClient',data, 'post','auth');
export const InviteSocialClient = (data) => fetch('Sales/InviteSocialClient',data, 'post','auth');
export const SalesPlan = (data) => fetch('Sales/SalesPlanNew',data, 'get','auth');
export const SalesSocialPlan = (data) => fetch('Sales/SalesSocialPlan',data, 'get','auth');
export const MyInviteClient = (data) => fetch('Sales/MyInviteClient',data, 'get','auth');
export const MyInviteClientNew = (data) => fetch('Sales/MyBindClient',data, 'get','auth');
export const SendPlanToClient = (data) => fetch('Sales/SendPlanToClient',data, 'post','auth');
export const ReturnInviter = (data) => fetch('Sales/ReturnInviter',data, 'post','auth');
/******** Line **********/
export const LineAuth = (data) => fetch('Line/Login',data, 'get','auth');
export const LineLogin = (data) => fetch('Line/Login',data, 'post','auth');
export const LineRegister = (data) => fetch('Line/Register',data, 'post','auth');

/******** Profile  **********/
export const EditMemberInfo = (data) => fetch('Profile/EditMemberInfo',data, 'post','auth');

/******** 業務 業績 **********/
export const getSalesPerformance = (data) => fetch('Sales/SalesPerformance',data, 'get','auth');
export const getSalesOrder = (data) => fetch('Sales/SalesOrder',data, 'get','auth');
export const getSalesUpgrade = (data) => fetch('Sales/SalesUpgrade',data, 'get','auth');
/******** 業務  **********/

export const getMySalesTeam = (data) => fetch('Sales/MySalesTeam',data, 'get','auth');

export const getMyClient= (data) => fetch('Sales/MyClient',data, 'get','auth');
/******** 訂單紀錄  **********/

export const getPaymentLog= (data) => fetch('History/PaymentLog',data, 'get','auth');
/******** 邀請碼檢查  **********/
export const getShareCodeCheck= (data) => fetch('Promotion/ShareCodeCheck',data, 'post','noauth');

/******** sales invitenum check  **********/
export const getCheckInvitecode= (data) => fetch('Sales/CheckInvitecode',data, 'get','noauth');
export const getCheckSales= (data) => fetch('Sales/CheckSales',data, 'get','auth');
export const DisabledView= (data) => fetch('History/DisabledView',data, 'get','auth');

/******** sales bank  **********/

export const getSalesBank= (data) => fetch('Sales/SalesAccount',data, 'get','auth');
export const postSalesBank= (data) => fetch('Sales/SalesAccount',data, 'post','auth');
export const postUpload= (data) => fetch('Sales/Upload',data, 'postfile','auth');
export const TestDev= (data) => fetch('TestDev',data, 'get','noauth');
export const getAppStatus= (data) => fetch('Console/appStatus',data, 'get','noauth');


/** NBPay  **/
export const NBpay = (data) => fetch('Shop/NBpay?pay=y',data, 'post','auth');
export const ChackOut = (data) => fetch('Shop/ChackOut?pay=y',data, 'post','auth');
export const PayCancel = (data) => fetch('Shop/PayCancel',data, 'post','auth');
export const ErrSend = (data) => fetch('Error/Send',data, 'post','noauth');
export const ProductNew = (data) => fetch('Shop/ProductNew',data, 'get','auth');

/************** New ************/

export const PayChackOut = (data) => fetch('Pay/User/CheckOut?pay=y',data, 'post','auth');

